export default "/images/framework/BackHome.7f501156.svg?7f501156";